<template>
    <div name="test" class="wrapper">
        <div class="home">
            솔닥 & 슬립큐
            <iframe 
                width="100%"
                src="https://in-app.stage.soldoc.co.kr/booking/profile?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxNzQ3OTA1NDAzOCIsImlhdCI6MTc0ODMyNTU2MiwiZXhwIjoyNzQ4MzI1NTYxLCJpc3MiOiJpc3N1ZXIifQ.u9xaLL2l0zr_hJ3tR9esOdQLeRpfIi4SJ0BegJt3d9U&data=%7B%22color%22%3A%7B%2220%22%3A%22%23353f4f%22%2C%2240%22%3A%22%233a3c40%22%2C%2260%22%3A%22%233FB68E%22%2C%22100%22%3A%22%236D5536%22%7D%2C%22logoUrl%22%3A%22https%3A%2F%2Fd1xox7kqzxfqzz.cloudfront.net%2Ftele%2Fimg%2Fsoldoc-inapp-logo.png%22%2C%22useAiMedicationGuidance%22%3Afalse%7D&skip_phone_number=true&redirect_template=%7B%22nextPathname%22%3A%22%22%2C%22params%22%3A%7B%22hospitalId%22%3A%221223232345%22%2C%22hospitalName%22%3A%22%ED%85%8C%EC%8A%A4%ED%8A%B8%EB%B3%91%EC%9B%90%28hospital1%29%22%2C%22departmentId%22%3A1%7D%7D"
            />
        </div>

    </div>
</template>

<script>
export default {
    name: 'test'
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    @media (min-width: 600px) {
        .home {
            width: 600px;
        }

    }
    iframe {
        border: none;
        height: calc(100vh - 20px);
    }
</style>


// WEBPACK FOOTER //
// src/page/Test.vue